export const DATAJSON = [
  // {
  //   type: "subtittle",
  //   label: "Datos de la empresa",
  //   fieldName: "",
  // },
  {
    type: "text",
    label: "Código cliente",
    fieldName: "managerId",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "Nombre de la sucursal",
    fieldName: "branchOfficeName",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "Razón social",
    fieldName: "socialReason",
    required: true,
    readOnly: true,
  },
  // {
  //   type: "text",
  //   label: "Nombre de fantasia",
  //   fieldName: "fantasyName",
  //   required: true,
  //   readOnly: true,
  // },
  {
    type: "text",
    label: "CUIT",
    fieldName: "cuit",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "Condición frente al iva",
    fieldName: "ivaCondition",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "Rubro de la empresa",
    fieldName: "heading",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "ART",
    fieldName: "ART",
    required: false,
    readOnly: true,
  },
  {
    type: "subtittle",
    label: "Datos de contacto",
    fieldName: "",
  },
  {
    type: "text",
    label: "Dirección",
    fieldName: "residence",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "Localidad",
    fieldName: "location",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "Provincia",
    fieldName: "province",
    required: true,
    readOnly: true,
  },
  /*   {
    type: "select",
    label: "Localidad",
    fieldName: "location",
    options: [
      {
        name: "CAPITAL", value: "Capital"
      }
    ],
    required: true
  },
  {
    type: "select",
    label: "Provincia",
    fieldName: "province",
    options: [
      {
        name: "CAPITAL", value: "Capital"
      }
    ],
    required: true
  }, */
  {
    type: "text",
    label: "Código postal",
    fieldName: "postalCode",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "Teléfono",
    fieldName: "phoneNumber",
    required: true,
    readOnly: true,
  },
  {
    type: "text",
    label: "Email",
    fieldName: "email",
    required: true,
    readOnly: true,
  },
];
